/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import {
  ActionIcon,
  Alert,
  Badge,
  Button,
  Group,
  LoadingOverlay,
  Paper,
  Space,
  Tooltip,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconAlertTriangle, IconDeviceFloppy, IconExternalLink, IconInfoCircle } from '@tabler/icons-react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useState } from 'react';
import { EventStatusType } from '../../../models/core/cache.type';
import { EventMeasurementSearchResponseType, EventRelationType } from '../../../models/core/events.type';
import { UserType } from '../../../models/core/users.type';
import eventsService from '../../../services/core/events.service';
import theme from '../../../theme';
import { formatCurrency, formatDateToString } from '../../../utils/formatter.utils';
import { newGuid } from '../../../utils/helper.utils';
import TableCellEllipsis from '../TableCellEllipsis/TableCellEllipsis';
import { EventMeasurementSearchFilter, FilterData } from './EventMeasurementSearchFilter';

type FormViewProps = {
  referenceData: {
    eventStatusData: EventStatusType[];
    userData: UserType[];
  };
  idsToBeDisabled: number[];
  idContrato: number;
  dataInicial: Date | undefined;
  dataFinal: Date | undefined;
  callback(items: EventMeasurementSearchResponseType[] | EventRelationType[], confirmed: boolean): void;
  zIndex: number;
};

export default function EventMeasurementSearch(props: FormViewProps) {
  const [eligibleData, setEligibleData] = useState<EventMeasurementSearchResponseType[]>([]);
  const [potentialData, setPotentialData] = useState<EventMeasurementSearchResponseType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState<EventMeasurementSearchResponseType[]>([]);

  const handleSubmit = async () => {
    props.callback(selectedData, true);
  };

  const clear = () => {
    setEligibleData([]);
    setPotentialData([]);
    setSelectedData([]);
  };

  const filter = async (inputFilterData: FilterData) => {
    const defaultLimit = 100;

    try {
      setLoading(true);

      const result = await eventsService.searchMeasurement({
        ...inputFilterData,
        idContrato: props.idContrato,
        dataInicial: inputFilterData.dataInicial
          ? moment(inputFilterData.dataInicial).format('yyyy-MM-DD')
          : null,
        dataFinal: inputFilterData.dataFinal ? moment(inputFilterData.dataFinal).format('yyyy-MM-DD') : null,
        limit: defaultLimit,
        offset: 0,
      });

      clear();

      const eligible = result.eligible || [];
      const eligibleIds = eligible.map((x) => x.idEvento);
      const disabledIds = props.idsToBeDisabled || [];
      const potential = (result.potential || []).filter(
        (x) => !eligibleIds.includes(x.idEvento) && !disabledIds.includes(x.idEvento)
      );

      setEligibleData(eligible);
      setPotentialData(potential);
    } catch (error: any) {
      showNotification({
        title: 'Eventos',
        message: error?.isBusinessException ? error.description : 'Não foi possível pesquisar eventos.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: EventMeasurementSearchResponseType[]) => {
      setSelectedData(selectedRows);
    },
    getCheckboxProps: (record: EventMeasurementSearchResponseType) => ({
      disabled: props.idsToBeDisabled.includes(record.idEvento),
      name: record.idEvento.toString(),
    }),
  };

  const columns: ColumnsType<EventMeasurementSearchResponseType> = [
    {
      title: '#',
      key: 'idEvento',
      sorter: (a, b) => {
        if (a.idEvento === b.idEvento) {
          return 0;
        }
        return a.idEvento > b.idEvento ? 1 : -1;
      },
      render: (row) => row.idEvento,
    },
    {
      title: 'Tipo',
      key: 'eventoTipo',
      sorter: (a, b) => a.eventoTipo.localeCompare(b.eventoTipo),
      render: (row) => <Badge variant="outline">{row.eventoTipo}</Badge>,
    },
    {
      title: 'Descrição',
      key: 'descricao',
      sorter: (a, b) => {
        const aValue = a.automatico
          ? a.descricao
          : a.resumoJSON?.residuo?.residuoCliente || a.resumoJSON?.servico?.servico || a.descricao;
        const bValue = b.automatico
          ? b.descricao
          : b.resumoJSON?.residuo?.residuoCliente || b.resumoJSON?.servico?.servico || b.descricao;
        return (aValue || '').localeCompare(bValue || '');
      },
      render: (row) => {
        let value = row.automatico
          ? row.descricao
          : `${row.resumoJSON?.residuo?.residuoCliente || row.resumoJSON?.servico?.servico || '-'} | ${
              row.descricao
            }`;
        if (value.startsWith('- |')) {
          value = value.replace('- |', '');
        }
        return <TableCellEllipsis label={value} numberOfChars={50} toolTipWidth={300} />;
      },
    },
    {
      title: 'Data',
      key: 'data',
      sorter: (a, b) => new Date(a.data).valueOf() - new Date(b.data).valueOf(),
      render: (row) => formatDateToString(row.data),
    },
    {
      title: 'Receita',
      key: 'receita',
      sorter: (a, b) => {
        const aValue = a.receita || 0;
        const bValue = b.receita || 0;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row) => <div>{formatCurrency(row.receita)}</div>,
    },
    {
      title: 'Despesa',
      key: 'despesa',
      sorter: (a, b) => {
        const aValue = a.despesa || 0;
        const bValue = b.despesa || 0;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row) => {
        if ((row.resumoJSON?.comissao?.porcentagem || 0) > 0) {
          return (
            <Group>
              <Tooltip
                withArrow
                transitionProps={{ transition: 'fade', duration: 200 }}
                label={<div>Despesa variável.</div>}
              >
                <div style={{ marginTop: 5, marginRight: -15 }}>
                  <IconInfoCircle size={18} color={theme?.colors?.accent?.[6]} />
                </div>
              </Tooltip>
              <div>{formatCurrency(row.despesa)}</div>
            </Group>
          );
        }

        return <div>{formatCurrency(row.despesa)}</div>;
      },
    },
    {
      title: 'Imposto',
      key: 'imposto',
      sorter: (a, b) => {
        const aValue = a.imposto || 0;
        const bValue = b.imposto || 0;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row) => <div>{formatCurrency(row.imposto)}</div>,
    },
    {
      title: 'Balanço',
      key: 'balanco',
      sorter: (a, b) => {
        const aValue = a.receita - a.despesa - a.imposto;
        const bValue = b.receita - b.despesa - b.imposto;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row) => {
        const total = row.receita - row.despesa - row.imposto;
        const color = total > 0 ? 'green' : total === 0 ? 'orange' : 'red';

        return <div style={{ color }}>{formatCurrency(total)}</div>;
      },
    },
    {
      title: 'Documentos',
      key: 'documentos',
      sorter: (a, b) => {
        const aValue = (a.resumoJSON?.documentos || []).length;
        const bValue = (b.resumoJSON?.documentos || []).length;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row) => {
        const documentos = row.resumoJSON?.documentos || [];
        if (documentos.length > 0) {
          return (
            <Group gap="xs">
              {documentos.map((y: any) => (
                <Badge key={newGuid()} variant="outline">{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
              ))}
            </Group>
          );
        }
        return '-';
      },
    },
    {
      title: 'Ações',
      width: '100px',
      render: (row) => (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Abrir">
          <ActionIcon
            size="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.primary?.[6] }}
            variant="outline"
            onClick={() => {
              const link = document.createElement('a');
              link.setAttribute('href', `/events?id=${row.idEvento}`);
              link.setAttribute('target', '_blank');
              link.click();
            }}
          >
            <IconExternalLink size={15} color={theme?.colors?.primary?.[6]} />
          </ActionIcon>
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <EventMeasurementSearchFilter
        eventStatusData={props.referenceData.eventStatusData}
        users={props.referenceData.userData}
        filter={filter}
        clear={clear}
        loading={loading}
        dataInicial={props.dataInicial}
        dataFinal={props.dataFinal}
        zIndex={props.zIndex + 1}
      />
      <div style={{ position: 'relative' }}>
        <LoadingOverlay visible={loading} />
        <Paper shadow="xs" p="md" withBorder>
          <Table
            showSorterTooltip={false}
            size="small"
            dataSource={eligibleData}
            columns={columns}
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            rowKey={(item) => item.idEvento}
            pagination={{
              pageSizeOptions: [10, 25, 50],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
            }}
          />
        </Paper>
        {potentialData.length > 0 && (
          <>
            <Space h="md" />
            <Alert
              icon={<IconAlertTriangle size={16} />}
              title="Eventos quase elegíveis"
              color="yellow"
              variant="light"
            >
              Existem eventos dentro do período que ainda exigem medição/finalização ou já possuem MTR/NF
              associada. Eles não entram neste fechamento agora, mas ficam visíveis para ação.
            </Alert>
            <Space h="md" />
            <Paper shadow="xs" p="md" withBorder>
              <Table
                showSorterTooltip={false}
                size="small"
                dataSource={potentialData}
                columns={columns}
                rowKey={(item) => item.idEvento}
                pagination={{
                  pageSizeOptions: [10, 25, 50],
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
                }}
              />
            </Paper>
          </>
        )}
        <Space h="xl" />
        <Group justify="right">
          <Button leftSection={<IconDeviceFloppy size={18} />} onClick={handleSubmit}>
            Salvar
          </Button>
        </Group>
      </div>
    </div>
  );
}
